import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordWebVisitorV1Body } from './record-web-visitor-v1-request';
import type { IRecordWebVisitorV1Response } from './record-web-visitor-v1-response';
import { recordWebVisitorV1ResponseSchema } from './record-web-visitor-v1-response';

export async function recordWebVisitorV1Api(
  body: IRecordWebVisitorV1Body,
): Promise<IValidatedResponse<IRecordWebVisitorV1Response>> {
  return postRequest<IRecordWebVisitorV1Response>({
    path: '/web/visitor/v1',
    body,
    schema: recordWebVisitorV1ResponseSchema,
  });
}
